import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const customBookingFormFieldOptionEntity: Entity = {
  model: model,
  repository: repository,
}

export default customBookingFormFieldOptionEntity
